import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { METHODOLOGY_EXPLAINER_PAGE_STRUCTURAL_INTEGRITY } from '@/config/constants';

import {
  Explainer,
  ExplainerBody,
  ExplainerContent,
  ExplainerCopy,
  ExplainerTitle,
  ExplainerTrigger,
  MethodologyLink,
} from './Explainer';

export const HabitatConnectivityExplainer = () => {
  const { t } = useTranslation();

  return (
    <Explainer>
      <ExplainerTrigger data-testid='habitat-connectivity-explainer'>{t('global.howDoWeMeasureThis')}</ExplainerTrigger>
      <ExplainerContent>
        <ExplainerTitle>
          {t('shared.ncaDetail.details.habitatConnectivity.explainers.howDoWeMeasureThis.title')}
        </ExplainerTitle>
        <Stack className='items-start pb-6'>
          <ExplainerBody className='pb-6'>
            <ExplainerCopy
              body={t('shared.ncaDetail.details.habitatConnectivity.explainers.howDoWeMeasureThis.body')}
            />
          </ExplainerBody>
          <MethodologyLink to={METHODOLOGY_EXPLAINER_PAGE_STRUCTURAL_INTEGRITY} />
        </Stack>
      </ExplainerContent>
    </Explainer>
  );
};
